<template lang="pug">
  div
    v-stepper(
      v-model="currentStep"
      flat
    )
      v-stepper-items
        v-stepper-content(
          v-for="(step, idx) in steps"
          :key="idx"
          :step="idx + 1"
          class="stepper-content"
        )
          div(
            class="profile-mono-create-eds-key__image"
            :class="{ 'align-end': currentStep === stepsMap.qr }"
          )
            div(class="profile-mono-create-eds-key__step-chip text-10px dark") {{ step.name }}
            v-img(
              :src="step.image.src"
              :max-width="step.image.width"
              :height="step.image.height"
            )
          div(class="profile-mono-create-eds-key__content")
            h2(
              class="fw-700 mb-2"
              :class="[xsDevice ? 'title-24px' : 'title-32px']"
            ) {{ step.title }}
            p(
              v-if="currentStep === stepsMap.options"
              class="fw-300 mb-6"
              :class="[xsDevice ? 'text-12px' : 'text-14px']"
            ) {{ $t('Select key type. Detailed instructions can be viewed on the official') }}
              a(
                href="https://ca.monobank.ua/"
                target="_blank"
                class="color-primary pl-1"
              ) {{ $t('website') }}
            p(
              v-else
              class="text-14px fw-300 mb-6"
            ) {{ step.subtitle }}
            div(
              v-if="currentStep === stepsMap.options"
              class="person-type-options"
            )
              button(
                v-for="(type, idx) in personTypes"
                :key="idx"
                class="person-type-options__item"
                :class="{ selected: selectedPersonType === type.value }"
                @click="selectPersonType(type.value)"
              )
                div(class="text-14px dark mb-1") {{ type.title }}
                div(class="text-14px fw-300") {{ type.subtitle }}
            div(v-else-if="currentStep === stepsMap.qr")
              qrcode-vue(
                :value="qrUrl"
                :size="252"
                class="d-flex justify-center"
              )
    div(
      class="profile-mono-create-eds-key__footer"
      :class="{ 'qr-step': currentStep === stepsMap.qr }"
    )
      div(class="profile-mono-create-eds-key__footer__left")
        v-btn(
          v-if="currentStep === stepsMap.qr"
          icon
          @click="currentStep = stepsMap.options"
        )
          e-svg-icon arrow-narrow-left
        div(class="profile-mono-create-eds-key__progress-bar-wrapper")
          v-progress-linear(
            :value="progress"
            rounded
            color="#8F257D"
            background-color="#121212"
            background-opacity="0.06"
            height="6"
          )
          div(class="text-12px fw-300") {{ progress }}%
      div(class="profile-mono-create-eds-key__actions")
        v-btn(
          v-if="currentStep === stepsMap.options"
          class="main-button"
          @click="handleBtnClick"
        ) {{ $t('Generate QR-code') }}
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'ProfileMonoCreateEdsKey',
  components: {
    QrcodeVue
  },
  mixins: [responsive],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      currentStep: 1,
      percent: {
        1: 35,
        2: 70
      },
      selectedPersonType: 'fop'
    }
  },
  computed: {
    qrUrl() {
      return this.isFOPSelected ? 'https://mbnk.app/kep/personal' : 'https://mbnk.app/kep/business'
    },
    progress() {
      return this.percent[this.currentStep] ?? 0
    },
    stepsMap() {
      return {
        options: 1,
        qr: 2
      }
    },
    personTypes() {
      return [
        {
          value: 'fop',
          title: this.$t('FOP'),
          subtitle: this.$t('For physical person-entrepreneurs')
        },
        {
          value: 'juridical',
          title: this.$t('Juridical person'),
          subtitle: this.$t('For legal entities and organizations')
        }
      ]
    },
    steps() {
      return [
        {
          name: 'mono',
          title: this.$t('Creating monoKEP'),
          subtitle: null,
          image: {
            src: require('~/assets/images/mono-eds-signature.png'),
            width: 162,
            height: 159
          }
        },
        {
          name: this.isFOPSelected ? this.$t('For FOP') : this.$t('For business'),
          title: this.$t('Scan QR-code'),
          subtitle: this.$t(
            'Scan this QR code with the camera of your phone and follow the instructions in the Monobank application to complete the creation of the key'
          ),
          image: {
            src: require('~/assets/images/mono-kep-steps.png'),
            width: this.xsDevice ? 270 : 500,
            height: this.xsDevice ? 100 : 180
          }
        }
      ]
    },
    isFOPSelected() {
      return this.selectedPersonType === 'fop'
    }
  },
  methods: {
    handleBtnClick() {
      if (this.currentStep === this.stepsMap.options) {
        this.currentStep = this.stepsMap.qr
      } else {
        // todo
      }
    },
    selectPersonType(value) {
      this.selectedPersonType = value
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-mono-create-eds-key {
  &__image {
    width: 100%;
    height: 200px;
    background: linear-gradient(91deg, #353744 -29.58%, #1d1e23 66.15%);
    position: relative;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__step-chip {
    padding: 2px 8px;
    border-radius: 20px;
    background: $white;

    position: absolute;
    top: 12px;
    left: 16px;
    z-index: map-get($zIndexes, 'base');

    @media (min-width: map-get($breakpoints, 'sm')) {
      top: 26px;
      left: 40px;
    }
  }

  &__content {
    padding: 16px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      padding: 32px 40px 0 40px;
    }
  }
  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    padding: 16px;
    gap: 24px;

    &.qr-step {
      gap: 0;
    }

    @media (min-width: map-get($breakpoints, 'sm')) {
      padding: 32px 40px 40px 40px;
      flex-direction: row;
      gap: 0;
    }

    &__left {
      display: flex;
      align-items: center;
      gap: 24px;
    }
  }
  &__actions {
    display: flex;
    align-items: center;
    gap: 16px;

    .v-btn {
      width: 228px;
    }
  }
  &__progress-bar-wrapper {
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
  }
}

.stepper-content {
  padding: 0;
}

.person-type-options {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: map-get($breakpoints, 'sm')) {
    grid-template-columns: repeat(2, 1fr);
  }

  &__item {
    text-align: left;
    background-color: $background-gray;
    border-radius: 12px;
    padding: 16px;
    border: 1px solid $background-gray;

    &.selected {
      border-color: $primary;
      background: $primary-light;
    }
  }
}
</style>
